import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="header-container">
            <ul>
                <li>
                    <Link to="/"><img src="/logo.png" className="logo" alt="Логотип"></img></Link>
                </li>

                <li>
                    <Link className="Link" to="/">Главная</Link>
                </li>

                <li>
                    <Link className="Link" to="/sites">Сайты</Link>
                </li>

                <li>
                    <Link className="Link" to="/contacts">Контакты</Link>
                </li>
            </ul>

            <div className="menu-container">
                <button className="menu-button" onClick={() => setIsOpen(!isOpen)}>≡</button>
                {isOpen && (
                    <ul className="menu-list">
                        <li><Link className="Link-button-header" to="/">Главная</Link></li>
                        <li><Link className="Link-button-header" to="/sites">Сайты</Link></li>
                        <li><Link className="Link-button-header" to="/contacts">Контакты</Link></li>
                        <li><Link className="Link-button-header" to="/partners">Партнёрки</Link></li>
                        <li><Link className="Link-button-header" to="/blog">Блог</Link></li>
                        <li><Link className="Link-button-header" to="/about">О нас</Link></li>
                        <li><Link className="Link-button-header" to="/profile">Профиль</Link></li>
                    </ul>
                )}
            </div>
        </div>
    );
}
